import { defineStore } from 'pinia'
// import SecureLS from "secure-ls";
// const ls = new SecureLS({ isCompression: false });

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isAuthenticated: false,
    user: {
      _id: '',
      role: '',
      name: '',
      email: '',
    }
    // loading: true
  }),

  getters: {
    isAuth: state => state.isAuthenticated,
    getEmail: state => state.user.email,
    getName: state => state.user.name,
    getUserId: state => state.user._id,
  },

  actions: {
    setAuth(payload) {
      this.isAuthenticated = payload;
    },

    setUser(payload) {
      this.user = payload;
    },
    
    // loading(payload) {
    //   this.loading = payload;
    // }
  }
})
        

  